import { HttpAxiosRequest } from '../httpAxiosBase'

export const HttpActionsValues = {
    getEndpoint: (systemCode: number, url: string) => `Workflow/${systemCode}/AccionesValor${url}`,

    getActionsValues: (systemCode: number) => HttpAxiosRequest.get(HttpActionsValues.getEndpoint(systemCode, ''))
}
